import module from 'finanzas/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('finances.serviciosAgregados', {
    url: '/servicios_agregados?{fecha_inicial:date}&{fecha_final:date}&{proyectos}',
    data: {
      title: 'Servicios agregados',
    },
    params: {
      inicio: {value: undefined},
      fin: {value: undefined},
      proyectos: {value: undefined, array: true},
    },
    resolve: {
      proyectos: ($stateParams) => $stateParams.proyectos,
      fechaInicial: ($stateParams) => $stateParams.fecha_inicial,
      fechaFinal: ($stateParams) => $stateParams.fecha_final,
    },
    template: '<finances-serviciosagregados fecha-inicial="fechaInicial" fecha-final="fechaFinal" proyectos="proyectos"></finances-serviciosagregados>',
    controller ($scope, fechaInicial, fechaFinal, proyectos) {
      $scope.fechaInicial = fechaInicial
      $scope.fechaFinal = fechaFinal
      $scope.proyectos = proyectos
    },
  })
})



// WEBPACK FOOTER //
// ./src/finanzas/routes/finances/serviciosAgregados.js